"use strict";
var lib_core = require("lib-core");
var editor_3d = require("editor-3d-light");
var ui_templates = require("ui-templates");
var THREE           = require("three");
var cio_datamodel = require("cio-datamodel");
var lib_geometry = require("lib-geometry");

var PackageFootprintViewerView = function(root, model, editorView, statemachine, config, scale, camera, masterView, placeOnBoardButton, placeAtCenterButton){
    var self = this;

     this.editorView = editorView;
     this.model = model;
     this.data = model.data;
     this.scale = scale;
    // this.hideGrid = config.hideGrid;
    
    this.config = config;
    this.masterView = masterView;
    this.placeOnBoardButton = placeOnBoardButton;
    this.placeAtCenterButton = placeAtCenterButton;
    this.statemachine = statemachine;

    this.packageObject = null;

    
    this.emptyObjModal = null;
    this.emptyObjLinkedModal = null;
    this.xrefObjModal = null;
    this.fusionLinkedModal = null;
    

    this.model.packageThreejsRenderGroup.onChange(this, function(val, old){
        if(!self.model.currentFootprintModel()) 
            self.createPackage();
    });

    this.model.switcherModel.selectedItem.onChange({}, function(val){
        if(val == null){
            self.createPackage();
        } else {
            self.editorView.removeMeshFromSelectableList(self.selectionObject);
            self.editorView.rootGroup.remove(self.packageObject);
            self.editorView.rootGroup.remove(self.selectionObject);
            self.editorView.destroyObject(self.packageObject);
            self.editorView.destroyObject(self.selectionObject);
        }
    });

    self.createPackage();

    if(masterView.model.wizardMode()) {
        if(this.placeOnBoardButton) this.placeOnBoardButton.hide();
        if(this.placeAtCenterButton) this.placeAtCenterButton.hide();
    } else {
        if(this.placeOnBoardButton) this.placeOnBoardButton.show();
        if(this.placeAtCenterButton) this.placeAtCenterButton.show();
    }

    masterView.model.wizardMode.onChange(this, function(mode) {
        if(!mode) {
            if(self.placeOnBoardButton) {
                self.placeOnBoardButton.show();
            }

            if(self.placeAtCenterButton) {
                self.placeAtCenterButton.show();
            }
        }
    });
    
    
    this.model.emptyObjModalShown.onChange(this, function(value){
        if(value) {
            self.showEmptyObjModal();
        } else {
            if(self.emptyObjModal){
                self.emptyObjModal.remove();
                self.emptyObjModal = null;
            }
        }
    }, 10);

    this.model.emptyObjLinkedModalShown.onChange(this, function(value){
        if(value) {
            self.showEmptyObjLinkedModal();
        } else {
            if(self.emptyObjLinkedModal){
                self.emptyObjLinkedModal.remove();
                self.emptyObjLinkedModal = null;
            }
        }
    }, 10);
    
    this.model.xrefObjModalShown.onChange(this, function(value){
        if(value) {
            self.showXrefObjModal();
        } else {
            if(self.xrefObjModal){
                self.xrefObjModal.remove();
                self.xrefObjModal = null;
            }
        }
    }, 10);
    
    
    this.model.fusionLinkedModalShown.onChange(this, function(value){
        if(value) {
            self.showFusionLinkedModal();
        } else {
            if(self.fusionLinkedModal){
                self.fusionLinkedModal.remove();
                self.fusionLinkedModal = null;
            }
        }
    }, 10);
};

PackageFootprintViewerView.prototype.createPackage = function () {
    var self = this;
   // if(!this.data.isAlive()) return;
    if(this.data.model3d() instanceof cio_datamodel.BoxData) return;

    self.editorView.removeMeshFromSelectableList(self.selectionObject);
    self.editorView.rootGroup.remove(self.packageObject);
    self.editorView.rootGroup.remove(self.selectionObject);
    self.editorView.destroyObject(self.packageObject);
    self.editorView.destroyObject(self.selectionObject);

    if(!this.model.packageThreejsRenderGroup()) return;

    var packageGroup = this.model.packageThreejsRenderGroup().clone();
    var matrix = new THREE.Matrix4();
    matrix.makeScale(self.scale, self.scale, self.scale);
    packageGroup.matrix = matrix;
    self.packageObject = new THREE.Group();
    self.packageObject.matrixAutoUpdate = false;
    self.packageObject.add(packageGroup);

    self.editorView.rootGroup.add(self.packageObject);

    var selectionGroup = this.model.boundingGeometry().clone();
    var matrix2 = new THREE.Matrix4();
    matrix2.makeScale(self.scale, self.scale, self.scale);
    selectionGroup.matrix = matrix2;
    self.selectionObject = new THREE.Group();
    self.selectionObject.matrixAutoUpdate = false;
    self.selectionObject.add(selectionGroup);

    self.editorView.addMeshToSelectableList(self.selectionObject, self.model);
    self.editorView.rootGroup.add(self.selectionObject);
    
    self.editorView.render();
}

PackageFootprintViewerView.prototype.showFusionLinkedModal = function() {
    var self = this;

    if(this.fusionLinkedModal){
        this.fusionLinkedModal.remove();
        this.fusionLinkedModal = null;
    }

    this.fusionLinkedModal = new ui_templates.Modal({
        target: $("body"),
        fields: {
            'title': "Model Linked to Fusion",
            'body': "This Library.io 3D Model cannot be repositioned because it is linked to a Fusion Package, which contains alignment information.",
            'modal': true
        }
    });

    this.fusionLinkedModal.setTheme("dark");
   
    var yes = this.fusionLinkedModal.addButton("OK");
    yes.$el.on('Cioui:Modal:ModalButton:clicked', function(){
        var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.CLOSE_FUSION_LINKED_MODAL);
        self.statemachine.handle(cEvent);
    });

    this.fusionLinkedModal.$el.on('Cioui:Modal:close:clicked', function(){
        var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.CLOSE_FUSION_LINKED_MODAL);
        self.statemachine.handle(cEvent);
    });
};

PackageFootprintViewerView.prototype.showEmptyObjModal = function() {
    var self = this;

    if(this.emptyObjModal){
        this.emptyObjModal.remove();
        this.emptyObjModal = null;
    }

    this.emptyObjModal = new ui_templates.Modal({
        target: $("body"),
        fields: {
            'title': "No Translatable Geometry",
            'body': "<b>The attached model file contains no solid geometry. </b></br></br>  The orange box is just a placeholder.",
            'modal': true
        }
    });

    this.emptyObjModal.setTheme("dark");
   
    var yes = this.emptyObjModal.addButton("OK");
    yes.$el.on('Cioui:Modal:ModalButton:clicked', function(){
        var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.CLOSE_EMPTY_OBJ_MODAL);
        self.statemachine.handle(cEvent);
    });

    this.emptyObjModal.$el.on('Cioui:Modal:close:clicked', function(){
        var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.CLOSE_EMPTY_OBJ_MODAL);
        self.statemachine.handle(cEvent);
    });
};

PackageFootprintViewerView.prototype.showEmptyObjLinkedModal = function() {
    var self = this;

    if(this.emptyObjLinkedModal){
        this.emptyObjLinkedModal.remove();
        this.emptyObjLinkedModal = null;
    }

    this.emptyObjLinkedModal = new ui_templates.Modal({
        target: $("body"),
        fields: {
            'title': "No Translatable Geometry",
            'body': "<b>This Library.io 3D Model is linked to a Fusion Package that contains no solid geometry. </b></br></br>  The orange box is a placeholder to represent this link.  You can still add geometry to the package and push changes from Fusion.",
            'modal': true
        }
    });

    this.emptyObjLinkedModal.setTheme("dark");

    var yes = this.emptyObjLinkedModal.addButton("OK");
    yes.$el.on('Cioui:Modal:ModalButton:clicked', function(){
        var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.CLOSE_EMPTY_OBJ_LINKED_MODAL);
        self.statemachine.handle(cEvent);
    });

    this.emptyObjLinkedModal.$el.on('Cioui:Modal:close:clicked', function(){
        var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.CLOSE_EMPTY_OBJ_LINKED_MODAL);
        self.statemachine.handle(cEvent);
    });
};

PackageFootprintViewerView.prototype.showXrefObjModal = function() {
    var self = this;

    if(this.xrefObjModal){
        this.xrefObjModal.remove();
        this.xrefObjModal = null;
    }

    this.xrefObjModal = new ui_templates.Modal({
        target: $("body"),
        fields: {
            'title': "Rendering Failure: External References",
            'body': "This Library.io 3D Model is linked to a Fusion Package that contains external references, which we are unable to render at this time.<br/><br/>  The orange box is a placeholder to represent the link.  We expect to be able to render this in the future.",
            'modal': true
        }
    });

    this.xrefObjModal.setTheme("dark");
   
    var yes = this.xrefObjModal.addButton("OK");
    yes.$el.on('Cioui:Modal:ModalButton:clicked', function(){
        var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.CLOSE_XREF_OBJ_MODAL);
        self.statemachine.handle(cEvent);
    });

    this.xrefObjModal.$el.on('Cioui:Modal:close:clicked', function(){
        var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.CLOSE_XREF_OBJ_MODAL);
        self.statemachine.handle(cEvent);
    });
};

module.exports = PackageFootprintViewerView;




